import { useIntl } from 'react-intl';

const VALIDATION_PREFIX = 'shifts.validation';

export interface ShiftValidationTranslations {
  nameRequired: string;
  daysRequired: string;
  timeZoneRequired: string;
  weekCountRequired: string;
}

export const useShiftValidationTranslations = (): ShiftValidationTranslations => {
  const intl = useIntl();

  return {
    nameRequired: intl.formatMessage({ id: `${VALIDATION_PREFIX}.nameRequired` }),
    daysRequired: intl.formatMessage({ id: `${VALIDATION_PREFIX}.daysRequired` }),
    timeZoneRequired: intl.formatMessage({ id: `${VALIDATION_PREFIX}.timeZoneRequired` }),
    weekCountRequired: intl.formatMessage({ id: `${VALIDATION_PREFIX}.weekCountRequired` }),
  };
};
